import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onBeforeUnmount } from "vue";
import throttle from "lodash/throttle";
import type Vue from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MonitorLayout',
  setup(__props) {

const fixedHeader = ref(false);
const warningMain = ref<Vue | null>(null);

const showHeaderFixedByScroll = throttle(() => {
  const main = warningMain.value?.$el as Element | undefined;
  if (!main) return;
  const rect = main.getBoundingClientRect();
  fixedHeader.value = rect.top < 0;
}, 300);

onMounted(() => {
  window.addEventListener("scroll", showHeaderFixedByScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", showHeaderFixedByScroll);
});

return { __sfc: true,fixedHeader, warningMain, showHeaderFixedByScroll }
}

})